import { useEffect, useState } from 'react'
import { api } from '../../api/client'
import type { Dcfh2Item, Fit } from '../../lib/types'

/**
 * The DCFH2 horizon view — the prototype's renderDCFH2, with the hardcoded DCFH2_PIPELINE
 * array replaced by GET /api/dcfh2 (seeded server-side, so the whole team edits one list).
 * The prototype styled these cards entirely inline; the classes live in global.css now.
 */
const FIT_LABEL: Record<Fit, string> = {
  high: 'Strong fit',
  medium: 'Good fit',
  low: 'Adjacent',
}

export function Dcfh2View() {
  const [items, setItems] = useState<Dcfh2Item[]>([])
  const [error, setError] = useState('')

  useEffect(() => {
    api
      .dcfh2()
      .then(setItems)
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load the DCFH2 pipeline.'))
  }, [])

  return (
    <div className="view active">
      <div className="dash-header">
        <h1 className="dash-title">DCFH2 Pipeline</h1>
        <div className="dash-sub">
          Upcoming DCFH2 RM6345 procurements — horizon view based on NHS published pipeline
        </div>
      </div>

      <div className="dcfh2-note">
        <strong>Framework:</strong> Digital Capability for Health 2 (DCFH2) · RM6345 · Burendo is a named
        supplier
      </div>

      {error && (
        <div className="err" role="alert">
          {error}
        </div>
      )}

      {items.map((p) => (
        <div className={`dcfh2-card ${p.fit}`} key={p.id}>
          <div className="dcfh2-row">
            <div className="dcfh2-main">
              <div className="dcfh2-title">{p.title}</div>
              <div className="dcfh2-start">
                📅 Estimated start: <strong>{p.startLabel}</strong>
              </div>
              {p.notes && <div className="dcfh2-notes">{p.notes}</div>}
              <div className="dcfh2-caps">
                {p.capabilities.map((c) => (
                  <span className="cap-tag" key={c}>
                    {c}
                  </span>
                ))}
              </div>
            </div>
            <span className={`fit-badge ${p.fit}`}>{FIT_LABEL[p.fit] ?? FIT_LABEL.low}</span>
          </div>
        </div>
      ))}
    </div>
  )
}
